export const GET_CURRENT_EXPO_BEGIN = "GET_CURRENT_EXPO_BEGIN";
export const GET_CURRENT_EXPO_SUCCESS = "GET_CURRENT_EXPO_SUCCESS";
export const GET_CURRENT_EXPO_ERROR = "GET_CURRENT_EXPO_ERROR";

export const GET_EDITION_EXPO_BEGIN = "GET_EDITION_EXPO_BEGIN";
export const GET_EDITION_EXPO_SUCCESS = "GET_EDITION_EXPO_SUCCESS";
export const GET_EDITION_EXPO_ERROR = "GET_EDITION_EXPO_ERROR";

export const GET_EDITION_CATEGORY_BEGIN = "GET_EDITION_CATEGORY_BEGIN";
export const GET_EDITION_CATEGORY_SUCCESS = "GET_EDITION_CATEGORY_SUCCESS";
export const GET_EDITION_CATEGORY_ERROR = "GET_EDITION_CATEGORY_ERROR";

export const GET_CURTAIN_RAISER_CATEGORY_BEGIN =
  "GET_CURTAIN_RAISER_CATEGORY_BEGIN";
export const GET_CURTAIN_RAISER_CATEGORY_SUCCESS =
  "GET_CURTAIN_RAISER_CATEGORY_SUCCESS";
export const GET_CURTAIN_RAISER_CATEGORY_ERROR =
  "GET_CURTAIN_RAISER_CATEGORY_ERROR";

export const GET_CURTAIN_RAISER_BEGIN = "GET_CURTAIN_RAISER_BEGIN";
export const GET_CURTAIN_RAISER_SUCCESS = "GET_CURTAIN_RAISER_SUCCESS";
export const GET_CURTAIN_RAISER_ERROR = "GET_CURTAIN_RAISER_ERROR";

export const GET_VOICE_CATEGORY_BEGIN = "GET_VOICE_CATEGORY_BEGIN";
export const GET_VOICE_CATEGORY_SUCCESS = "GET_VOICE_CATEGORY_SUCCESS";
export const GET_VOICE_CATEGORY_ERROR = "GET_VOICE_CATEGORY_ERROR";

export const GET_VOICE_BEGIN = "GET_VOICE_BEGIN";
export const GET_VOICE_SUCCESS = "GET_VOICE_SUCCESS";
export const GET_VOICE_ERROR = "GET_VOICE_ERROR";

export const GET_SPONSER_CATEGORY_BEGIN = "GET_SPONSER_CATEGORY_BEGIN";
export const GET_SPONSER_CATEGORY_SUCCESS = "GET_SPONSER_CATEGORY_SUCCESS";
export const GET_SPONSER_CATEGORY_ERROR = "GET_SPONSER_CATEGORY_ERROR";

export const GET_CURRENT_CONTACT_BEGIN = "GET_CURRENT_CONTACT_BEGIN";
export const GET_CURRENT_CONTACT_SUCCESS = "GET_CURRENT_CONTACT_SUCCESS";
export const GET_CURRENT_CONTACT_ERROR = "GET_CURRENT_CONTACT_ERROR";

export const GET_ABOUTUS_BEGIN = "GET_ABOUTUS_BEGIN";
export const GET_ABOUTUS_SUCCESS = "GET_ABOUTUS_SUCCESS";
export const GET_ABOUTUS_ERROR = "GET_ABOUTUS_ERROR";

export const GET_DIRECTOR_BEGIN = "GET_DIRECTOR_BEGIN";
export const GET_DIRECTOR_SUCCESS = "GET_DIRECTOR_SUCCESS";
export const GET_DIRECTOR_ERROR = "GET_DIRECTOR_ERROR";

export const GET_EXHIBITION_BEGIN = "GET_EXHIBITION_BEGIN";
export const GET_EXHIBITION_SUCCESS = "GET_EXHIBITION_SUCCESS";
export const GET_EXHIBITION_ERROR = "GET_EXHIBITION_ERROR";

export const GET_CONFERENCE_BEGIN = "GET_CONFERENCE_BEGIN";
export const GET_CONFERENCE_SUCCESS = "GET_CONFERENCE_SUCCESS";
export const GET_CONFERENCE_ERROR = "GET_CONFERENCE_ERROR";

export const GET_WHYVISIT_BEGIN = "GET_WHYVISIT_BEGIN";
export const GET_WHYVISIT_SUCCESS = "GET_WHYVISIT_SUCCESS";
export const GET_WHYVISIT_ERROR = "GET_WHYVISIT_ERROR";

export const GET_CONTACT_US_BEGIN = "GET_CONTACT_US_BEGIN";
export const GET_CONTACT_US_SUCCESS = "GET_CONTACT_US_SUCCESS";
export const GET_CONTACT_US_ERROR = "GET_CONTACT_US_ERROR";

export const POST_EXPO_CONTACT_US_BEGIN = "POST_EXPO_CONTACT_US_BEGIN";
export const POST_EXPO_CONTACT_US_SUCCESS = "POST_EXPO_CONTACT_US_SUCCESS";
export const POST_EXPO_CONTACT_US_ERROR = "POST_EXPO_CONTACT_US_ERROR";

export const GET_REGISTER_FORM_BEGIN = "GET_REGISTER_FORM_BEGIN";
export const GET_REGISTER_FORM_SUCCESS = "GET_REGISTER_FORM_SUCCESS";
export const GET_REGISTER_FORM_ERROR = "GET_REGISTER_FORM_ERROR";

export const GET_REGISTER_DETAIL_EXPO_BEGIN = "GET_REGISTER_DETAIL_EXPO_BEGIN";
export const GET_REGISTER_DETAIL_EXPO_SUCCESS =
  "GET_REGISTER_DETAIL_EXPO_SUCCESS";
export const GET_REGISTER_DETAIL_EXPO_ERROR = "GET_REGISTER_DETAIL_EXPO_ERROR";

export const GET_VISITOR_FORMAT_BEGIN = "GET_VISITOR_FORMAT_BEGIN";
export const GET_VISITOR_FORMAT_SUCCESS = "GET_VISITOR_FORMAT_SUCCESS";
export const GET_VISITOR_FORMAT_ERROR = "GET_VISITOR_FORMAT_ERROR";

export const SUBMIT_DOMESTIC_VISITOR_BEGIN = "SUBMIT_DOMESTIC_VISITOR_BEGIN";
export const SUBMIT_DOMESTIC_VISITOR_SUCCESS =
  "SUBMIT_DOMESTIC_VISITOR_SUCCESS";
export const SUBMIT_DOMESTIC_VISITOR_ERROR = "SUBMIT_DOMESTIC_VISITOR_ERROR";

export const SUBMIT_INTERNATIONAL_VISITOR_BEGIN =
  "SUBMIT_INTERNATIONAL_VISITOR_BEGIN";
export const SUBMIT_INTERNATIONAL_VISITOR_SUCCESS =
  "SUBMIT_INTERNATIONAL_VISITOR_SUCCESS";
export const SUBMIT_INTERNATIONAL_VISITOR_ERROR =
  "SUBMIT_INTERNATIONAL_VISITOR_ERROR";

export const SUBMIT_EXHIBITOR_BEGIN = "SUBMIT_EXHIBITOR_BEGIN";
export const SUBMIT_EXHIBITOR_SUCCESS = "SUBMIT_EXHIBITOR_SUCCESS";
export const SUBMIT_EXHIBITOR_ERROR = "SUBMIT_EXHIBITOR_ERROR";

export const SUBMIT_MANUFACTURER_EXHIBITOR_BEGIN =
  "SUBMIT_MANUFACTURER_EXHIBITOR_BEGIN";
export const SUBMIT_MANUFACTURER_EXHIBITOR_SUCCESS =
  "SUBMIT_MANUFACTURER_EXHIBITOR_SUCCESS";
export const SUBMIT_MANUFACTURER_EXHIBITOR_ERROR =
  "SUBMIT_MANUFACTURER_EXHIBITOR_ERROR";

export const GET_COUNTRY_BEGIN = "GET_COUNTRY_BEGIN";
export const GET_COUNTRY_SUCCESS = "GET_COUNTRY_SUCCESS";
export const GET_COUNTRY_ERROR = "GET_COUNTRY_ERROR";

export const GET_STATE_BEGIN = "GET_STATE_BEGIN";
export const GET_STATE_SUCCESS = "GET_STATE_SUCCESS";
export const GET_STATE_ERROR = "GET_STATE_ERROR";

export const GET_CITY_BEGIN = "GET_CITY_BEGIN";
export const GET_CITY_SUCCESS = "GET_CITY_SUCCESS";
export const GET_CITY_ERROR = "GET_CITY_ERROR";
